import { createServerFn } from "@tanstack/react-start";
import { createClient } from "@supabase/supabase-js";
import { supabaseAdmin } from "@/integrations/supabase/client.server";

const DEMO_EMAIL = "demo@adkavi.com";
// Server-only. Never returned to the client.
const DEMO_PASSWORD = "Demo!Adkavi-9f3c2e7b1a8d4-ShowMe";

export const demoLogin = createServerFn({ method: "POST" }).handler(async () => {
  // Ensure the demo user exists & is confirmed.
  const { data: list, error: listError } = await supabaseAdmin.auth.admin.listUsers({
    page: 1,
    perPage: 200,
  });
  if (listError) {
    console.error("demoLogin listUsers failed", listError);
    throw new Error("Demo account is unavailable. Please try again.");
  }

  const existing = list.users.find((u) => u.email?.toLowerCase() === DEMO_EMAIL);

  if (!existing) {
    const { error: createError } = await supabaseAdmin.auth.admin.createUser({
      email: DEMO_EMAIL,
      password: DEMO_PASSWORD,
      email_confirm: true,
      user_metadata: { display_name: "Demo User", is_demo: true },
    });
    if (createError && !/already/i.test(createError.message)) {
      console.error("demoLogin createUser failed", createError);
      throw new Error("Could not provision the demo account.");
    }
  } else if (!existing.email_confirmed_at) {
    await supabaseAdmin.auth.admin.updateUserById(existing.id, {
      password: DEMO_PASSWORD,
      email_confirm: true,
    });
  }

  // Sign in server-side and return only the session tokens.
  // The password never leaves the server.
  const authClient = createClient(
    process.env.SUPABASE_URL!,
    process.env.SUPABASE_PUBLISHABLE_KEY!,
    { auth: { persistSession: false, autoRefreshToken: false } },
  );
  const { data, error } = await authClient.auth.signInWithPassword({
    email: DEMO_EMAIL,
    password: DEMO_PASSWORD,
  });
  if (error || !data.session) {
    console.error("demoLogin signIn failed", error);
    throw new Error("Demo sign-in failed. Please try again.");
  }
  return {
    access_token: data.session.access_token,
    refresh_token: data.session.refresh_token,
  };
});
